/**
 * Generation counter for auth token writes.
 * Bump on logout / session identity changes so in-flight refresh responses
 * cannot overwrite a newer login (e.g. admin re-login after a stuck impersonation).
 */
let authWriteGeneration = 0;

export function bumpAuthWriteGeneration(): number {
  authWriteGeneration += 1;
  return authWriteGeneration;
}

export function getAuthWriteGeneration(): number {
  return authWriteGeneration;
}

export function isStaleAuthWrite(generationAtStart: number): boolean {
  return generationAtStart !== authWriteGeneration;
}
